import { render, staticRenderFns } from "./SurveyButton.vue?vue&type=template&id=3b328ed2&"
import script from "./SurveyButton.vue?vue&type=script&lang=js&"
export * from "./SurveyButton.vue?vue&type=script&lang=js&"
import style0 from "./SurveyButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports